import { useTooltip } from "../hooks/useGetTooltip"

export const QuizTitle = ({title, subTitle}: QuizTitleType): JSX.Element => {
    const contentTitle = useTooltip(title)
    const contentSubtitle = useTooltip(subTitle)
    return(
        <div className="quizTitle">
            <h3>{contentTitle && [...contentTitle]}</h3>
            <p>{contentSubtitle && [...contentSubtitle]}</p>
            <hr />
        </div>
    )
}

type QuizTitleType = {
    title: string,
    subTitle?: string
}

